import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AddNewCategoryService {

  constructor(private _http: HttpClient) { }

  addcategory(data) {
    return this._http.post(environment.api_url+'addcategory',data);
  }

}
